import React, { useCallback, useState } from 'react';
import { Select, Typography } from 'antd';
import { Section } from '../styles';
import { Notice } from '../../../Modules/Notice/Model/Notice';
import NoticeTable from '../../NoticesPage/components/NoticeTable';
import NoticeViewModal from '../../NoticesPage/components/NoticeViewModal';

const { Title } = Typography;
const { Option } = Select;

interface NoticeSectionProps {
  notices: Notice[];
}

const NoticeSection: React.FC<NoticeSectionProps> = ({ notices }) => {
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [viewOpen, setViewOpen] = useState(false);
  const [selected, setSelected] = useState<Notice | null>(null);

  const handleView = useCallback((n: Notice) => {
    setSelected(n);
    setViewOpen(true);
  }, []);

  return (
    <Section>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Title level={4}>공지사항</Title>

        <Select value={perPage} style={{ width: 120 }} onChange={(v) => {
          setPerPage(v);
          setCurrentPage(1);
        }}>
          <Option value={10}>10개씩</Option>
          <Option value={30}>30개씩</Option>
          <Option value={50}>50개씩</Option>
          <Option value={100}>100개씩</Option>
        </Select>
      </div>
      <NoticeTable
        data={notices}
        total={notices.length}
        perPage={perPage}
        currentPage={currentPage}
        onView={handleView}
        onPageChange={(page) => setCurrentPage(page)}
      />
      <NoticeViewModal
        notice={selected}
        open={viewOpen}
        onClose={() => { setViewOpen(false); setSelected(null); }}
      />
    </Section>
  );
};

export default NoticeSection;
